
/* injects from baggage-loader */
require('./style.styl');

import React, {PureComponent} from 'react'
import Icon from 'components/Icon'
import PropTypes from 'prop-types'

export default class CodeBlock extends PureComponent {
  static propTypes = {
    code: PropTypes.string.isRequired
  }

  render() {
    const {code} = this.props
    return (
      <div className='codeBlock'>
        <p className='code'>{code}</p>
        <Icon
          className='copyIcon'
          name={'coppy'}
          onClick={this.handleCopy(code)}
          width='32px'
          height='22px'
        />
        <button plain='true' onClick={this.handleCopy(code)}>
          Copy to clipboard
        </button>
      </div>
    )
  }

  handleCopy = content => () => {
    const el = document.createElement('textarea')
    el.value = content
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    el.remove()
    // eslint-disable-next-line no-alert
    alert(`Copied to clipboard: ${content}`)
  }
}



// WEBPACK FOOTER //
// ./client/components/CodeBlock/index.js